import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const SmsConsentBoxWrapper = styled(Box)(
  ({ theme }) => `
    width: 100%;
    margin-top: ${theme.spacing(6)};
    display: flex;
    align-items: flex-start;
    gap: ${theme.spacing(2)};

    .MuiCheckbox-root {
      padding: 0;
    }
`
);
